import { useTranslation } from 'react-i18next';
import { NoUnitsFoundContainer } from './UnitList.styles';
import { AddExtraUnits } from './AddExtraUnits';

const NoUnitsFound = () => {
  const { t } = useTranslation();

  return (
    <NoUnitsFoundContainer>
      <span className="no-units-found-text">
        {t('pageProperty.units.noUnitsYet')}
      </span>
      <AddExtraUnits />
    </NoUnitsFoundContainer>
  );
};

export default NoUnitsFound;
